import { createApp } from "vue"
import { createPinia } from "pinia"
import App from "@/apps/recruiter/App.vue"
import router from "@/apps/recruiter/router"
import { Quasar } from "quasar"
import quasarLang from "quasar/lang/ru"
import Vue3Toasity, { ToastContainerOptions } from "vue3-toastify"

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(Quasar, {
    plugins: {},
    lang: quasarLang
})
app.use(Vue3Toasity, {
    autoClose: 3000,
    position: "top-center",
    closeButton: true
} as ToastContainerOptions)

app.mount("#app")
